import { createSlice } from '@reduxjs/toolkit'
import { ECompetitorTypes, IRiderSignupForm } from '../../types/competitor_types'
import { RootState } from '../store'
import { IInputHorseData, IInputUserData } from '../../components/home/types/inputData'
import { IUserInterface } from '../../models/users/user.interface'

export type IHorseProfileRegistration = {
  horsePicture: File
  inputData: IInputHorseData
}

interface IState {
  profileType: ECompetitorTypes
  eventId: string | null
  rider: {
    signupForm: IRiderSignupForm
    picture: File | null
  } | null
  horse: IHorseProfileRegistration | null
  team: IUserInterface[]
  newTeamRider: {
    inputData: IInputUserData
    picture: File | null
  } | null
  search: string
}

const initialState: IState = {
  rider: null,
  horse: null,
  eventId: null,
  team: [],
  newTeamRider: null,
  profileType: ECompetitorTypes.none,
  search: '',
}

export const riderProfileRegistrationSlice = createSlice({
  name: 'riderProfileRegistration',
  initialState,
  reducers: {
    setProfileType: (state, action) => {
      state.profileType = action.payload
    },
    setEventId: (state, action) => {
      state.eventId = action.payload
    },
    setRiderForm: (state, action) => {
      state.rider = action.payload
    },
    setHorse: (state, action) => {
      state.horse = action.payload
    },
    setTeam: (state, action) => {
      state.team = action.payload
    },
    setNewTeamRider: (state, action) => {
      state.newTeamRider = action.payload
    },
    setSearch: (state, action) => {
      state.search = action.payload
    },
    clear: (state) => {
      state.rider = null
      state.horse = null
      state.eventId = null
      state.profileType = ECompetitorTypes.none
      state.newTeamRider = null
      state.search = ''
      state.team = []
    },
  },
})

export const riderProfileRegistrationActions = riderProfileRegistrationSlice.actions

export const selectRiderProfileRegistration = (state: RootState) => state.riderProfileRegistration
export const selectRiderProfileHorse = (state: RootState) => state.riderProfileRegistration.horse
export const selectRiderProfileType = (state: RootState) =>
  state.riderProfileRegistration.profileType
export const selectRiderProfileNewTeamRider = (state: RootState) =>
  state.riderProfileRegistration.newTeamRider
export const selectRiderProfileSearch = (state: RootState) =>
  state.riderProfileRegistration.search
export const selectRiderProfileTeam = (state: RootState) => state.riderProfileRegistration.team
export const selectRiderProfileRider = (state: RootState) => state.riderProfileRegistration.rider
export const selectRiderProfileEventId = (state: RootState) =>
  state.riderProfileRegistration.eventId

export default riderProfileRegistrationSlice.reducer
